import { computed, Injectable, signal } from '@angular/core';

// TODO move to model?¿?
export enum EBreakpoint {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
}

export const BREAKPOINT_VALUES = {
  [EBreakpoint.XS]: 576,
  [EBreakpoint.SM]: 768,
  [EBreakpoint.MD]: 992,
  [EBreakpoint.LG]: 1200,
} as const;
@Injectable()
export class ScreensizeService {
  private readonly _currentBreakpoint = signal<string>(this.calculateBreakpoint(window.innerWidth));

  public readonly isDesktopView = computed(() => {
    const breakpoint = this._currentBreakpoint();
    return breakpoint === EBreakpoint.MD || breakpoint === EBreakpoint.LG || breakpoint === EBreakpoint.XL;
  });

  // public readonly isMobile = computed(() => {
  //   const breakpoint = this._currentBreakpoint();
  //   return breakpoint === EBreakpoint.XS || breakpoint === EBreakpoint.SM;
  // });

  // public readonly isLGorLess = computed(() => {
  //   const breakpoint = this._currentBreakpoint();
  //   return breakpoint === EBreakpoint.XS || breakpoint === EBreakpoint.SM;
  // });

  //////

  public readonly isXsDown = computed(() => {
    return this._currentBreakpoint() === EBreakpoint.XS;
  });

  public readonly isSmDown = computed(() => {
    const breakpoint = this._currentBreakpoint();
    return breakpoint === EBreakpoint.XS || breakpoint === EBreakpoint.SM;
  });

  public readonly isMdDown = computed(() => {
    const breakpoint = this._currentBreakpoint();
    return breakpoint === EBreakpoint.XS || breakpoint === EBreakpoint.SM || breakpoint === EBreakpoint.MD;
  });

  public readonly isLgDown = computed(() => {
    const breakpoint = this._currentBreakpoint();
    return (
      breakpoint === EBreakpoint.XS ||
      breakpoint === EBreakpoint.SM ||
      breakpoint === EBreakpoint.MD ||
      breakpoint === EBreakpoint.LG
    );
  });

  public readonly isSmUp = computed(() => {
    const breakpoint = this._currentBreakpoint();
    return (
      breakpoint === EBreakpoint.SM ||
      breakpoint === EBreakpoint.MD ||
      breakpoint === EBreakpoint.LG ||
      breakpoint === EBreakpoint.XL
    );
  });

  public readonly isMdUp = computed(() => {
    const breakpoint = this._currentBreakpoint();
    return breakpoint === EBreakpoint.MD || breakpoint === EBreakpoint.LG || breakpoint === EBreakpoint.XL;
  });

  public readonly isLgUp = computed(() => {
    const breakpoint = this._currentBreakpoint();
    return breakpoint === EBreakpoint.LG || breakpoint === EBreakpoint.XL;
  });

  public readonly isXlUp = computed(() => {
    return this._currentBreakpoint() === EBreakpoint.XL;
  });

  // TODO use in components instead !isDesktopView()
  public readonly isMobile = computed(() => this.isSmDown());

  public readonly isDesktop = computed(() => this.isMdUp());

  constructor() {
    this.initResizeListener();
  }

  private initResizeListener(): void {
    let resizeTimeout: number;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = window.setTimeout(() => {
        const newBreakpoint = this.calculateBreakpoint(window.innerWidth);

        if (newBreakpoint !== this._currentBreakpoint()) {
          this._currentBreakpoint.set(newBreakpoint);
        }
      }, 16); //  aprox 60fps
    });
  }

  private calculateBreakpoint(width: number): EBreakpoint {
    if (width < BREAKPOINT_VALUES[EBreakpoint.XS]) return EBreakpoint.XS;
    if (width < BREAKPOINT_VALUES[EBreakpoint.SM]) return EBreakpoint.SM;
    if (width < BREAKPOINT_VALUES[EBreakpoint.MD]) return EBreakpoint.MD;
    if (width < BREAKPOINT_VALUES[EBreakpoint.LG]) return EBreakpoint.LG;
    return EBreakpoint.XL;
  }
}
